<template>
  <div class="colunaIcone">
    <i class="el-icon-circle-check" v-if="consultaConfirmada"></i>
  </div>
</template>
<script>
export default {
  name: 'colunaIcone',
  props: ['column', 'row'],
  computed: {
    consultaConfirmada () {
      return this.row.configuracoes.agendaConfirmada
    }
  }
}
</script>
<style lang="less" scoped>
.colunaIcone {
  i {
    color: #09B531;
    font-size: 20px;
    padding-top: 2px;
  }
}
</style>
